// extracted by mini-css-extract-plugin
module.exports = {"navPc":"nav_pc-module--nav-pc--O2phH"};